/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	OrganisationAiSettingsShowPathParams,
	OrganisationAiSettingsShowResponse,
} from '../types/OrganisationAiSettingsShow'

/**
 * GET /organisations/:organisation/ai-settings
 * @see backend/nexus/modules/Organisation/Http/Controllers/OrganisationAiSettingsController.php OrganisationAiSettingsController::show
 */
export async function organisationAiSettingsShow(
	organisation: OrganisationAiSettingsShowPathParams['organisation'],
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<OrganisationAiSettingsShowResponse>> {
	return axiosInstance.get(`/organisations/${organisation}/ai-settings`, config)
}
